export default "__VITE_ASSET__BehzJeyo__"